import 'devextreme/dist/css/dx.common.css';
//import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.material.blue.light.compact.css';
import React, { Component, useEffect, useState } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import API from './API'
import { setOnError, load } from './Manager';
import { CModal, CModalBody, CModalHeader, CModalTitle } from '@coreui/react';
/* DEVEXPRESS CONFIG */
import itMessages from "./languages/it.json";
import { locale, loadMessages } from "devextreme/localization";
import config from 'devextreme/core/config';
import { VMToaster } from './rapporti/components/VMToaster';
import { ModalLoading } from './rapporti/components/ModalLoading';
import { useHistory } from 'react-router';
import ModalCambioPassword from './rapporti/forms/FormCambioPassword';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)


// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));


class App extends Component {

  constructor(props) {
    super(props);
    loadMessages(itMessages);
    locale(navigator.language);
    config({ defaultCurrency: 'EUR' });
  }

  render() {

    return (
      <>
        <ModalLoading />
        <VMToaster />
        <HashRouter>
          <React.Suspense fallback={loading}>
            <AppFlow />
          </React.Suspense>
        </HashRouter>
      </>
    );
  }
}

const AppFlow = (props) => {

  const history = useHistory()
  const [error, setError] = useState(null)

  const onError = (error) => {
    if (error) {
      setError(error)
      console.log(error)
    }
  }

  setOnError(onError)

  const [user, setUser] = useState(null)
  const [loggedIn, setLoggedIn] = useState(true);
  const [visCambioPwd, setVisCambioPwd] = useState(false)
  const [pageReloaded, setPageReloaded] = useState(true);

  useEffect(() => {
    const getUserInfo = async () => {
      try {        
        setPageReloaded(false);
        load(true)
        const res = await API.getUserInfo();
        setUser(res)
        if (res.password == 'geicogeico')
          setVisCambioPwd(true)
        setLoggedIn(true);        
        setError(null)
        load(false)
      } catch (err) {
        setPageReloaded(false);
        setUser(null)
        setError(null)
        setLoggedIn(false);
        load(false)
      }
    }
    if (pageReloaded)
      getUserInfo();
  }, [pageReloaded])


  const setRed = (to) => {
    history.push(to)
  }

  return (
    <Switch>
      {!loggedIn ?
        <Login setLoggedIn={setLoggedIn} setPageReloaded={setPageReloaded} {...props} /> :
        <>          
          <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
          <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
          <Route path="/" name="Home">
            {user && loggedIn ?
              <TheLayout {...props} user={user} setPageReloaded={setPageReloaded} setRedirectTo={setRed} /> :
              <Login setLoggedIn={setLoggedIn} setPageReloaded={setPageReloaded} {...props} />
            }
            {user && loggedIn ?
              <ModalCambioPassword visible={visCambioPwd} close={() => setVisCambioPwd(false)} record={user} /> :
              <></>
            }
            {error ?
              <CModal visible={error ? true : false} closeButton onClose={() => setError(null)}>
                <CModalHeader className='bg-danger'>
                  <CModalTitle>Errore</CModalTitle>
                </CModalHeader>
                <CModalBody>
                  {error}
                </CModalBody>
              </CModal>
              : <></>
            }
          </Route>
        </>}
    </Switch>
  )
}


export default App;
